import produce from "immer"
import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initMarkovGroupStateState: types.MarkovGroupStateState = {
    groupStateList: null,

    assignedStates: {
        stateIds: null,
        sortColumn: "order",
        sortOrder: ASC,
        filters: {
            search: null,
        },
    },
    notAssignedStates: {
        stateIds: null,
        sortColumn: "order",
        sortOrder: ASC,
        filters: {
            search: null,
        },
        selected: null,
    },

    reloadGroupStateList: true,
}

const markovGroupStateReducer = produce((
    draft: types.MarkovGroupStateState = initMarkovGroupStateState,
    action: ActionTypes = null,
): types.MarkovGroupStateState => {
    switch (action.type) {
        case types.MARKOV_GROUP_STATE_LIST:
            draft.groupStateList = {
                ...draft.groupStateList,
                ...action.groupStateList,
            }
            return draft

        case types.ASSIGNED_MARKOV_GROUP_STATE_IDS:
            draft.assignedStates.stateIds = action.stateIds
            return draft

        case types.ASSIGNED_MARKOV_GROUP_STATE_SORT:
            draft.assignedStates.sortColumn = action.sortColumn
            draft.assignedStates.sortOrder = action.sortOrder
            return draft

        case types.ASSIGNED_MARKOV_GROUP_STATE_FILTERS:
            draft.assignedStates.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_MARKOV_GROUP_STATE_IDS:
            draft.notAssignedStates.stateIds = action.stateIds
            return draft

        case types.NOT_ASSIGNED_MARKOV_GROUP_STATE_SORT:
            draft.notAssignedStates.sortColumn = action.sortColumn
            draft.notAssignedStates.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_MARKOV_GROUP_STATE_FILTERS:
            draft.notAssignedStates.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_MARKOV_GROUP_STATE_SELECTED:
            draft.notAssignedStates.selected = action.selected
            return draft

        case types.MARKOV_GROUP_STATE_RELOAD_LIST:
            draft.reloadGroupStateList = action.value
            return draft

        default:
            return draft
    }
})
export default markovGroupStateReducer
